// src/lib/utils/dateUtils.js

/**
 * 날짜 문자열을 한국 시간 기준의 가독성 있는 형식으로 변환합니다.
 *
 * @param {string | Date} dateInput - ISO 날짜 문자열 또는 Date 객체
 * @returns {string} - 포맷된 날짜 문자열 (예: '2025.01.01 23:32:11')
 */
export function formatDateToKorean(dateInput) {
    if (!dateInput) return '';
    const date = new Date(dateInput);
    return date.toLocaleString('ko-KR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });
}